import React from 'react'
import Card from '../../../common/Card'
import ReactHighcharts from 'react-highcharts';
import HighchartsMore from 'highcharts-more';
import Pareto from 'highcharts/modules/pareto';
import SolidGauge from 'highcharts/modules/solid-gauge';
import Highcharts from "@material-ui/core/es/styles/withStyles";
import {convertSecondsToMinutesSecondsFormat} from "../../../common/Util";
import CustomTheme from "../../../common/CustomTheme";

HighchartsMore(ReactHighcharts.Highcharts);
Pareto(ReactHighcharts.Highcharts);
SolidGauge(ReactHighcharts.Highcharts);


var config = {
    chart: {
        type: 'column'
    },
    title: {
        text: 'Ritmo Pneus/Hora - Operador'
    },
    xAxis: {
        categories: []
    },
    yAxis: [{
        min: 0,
        title: {
            text: 'Pneus / hora'
        },
        stackLabels: {
            enabled: true,
            style: {
                fontWeight: 'bold',
                color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
            }
        }
    },
        {
            min: 0,
            title: {
                text: '# pneus'
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                }
            },
            opposite: true
        },
        {
            min: 0,
            title: {
                text: '# horas'
            },
            stackLabels: {
                enabled: true,
                style: {
                    fontWeight: 'bold',
                    color: (Highcharts.theme && Highcharts.theme.textColor) || 'gray'
                }
            },
            opposite: true
        }],
    legend: {
        align: 'center',
        x: -30,
        verticalAlign: 'bottom',
        y: 25,
        floating: true,
        backgroundColor: (Highcharts.theme && Highcharts.theme.background2) || 'white',
        borderColor: '#CCC',
        borderWidth: 1,
        shadow: false
    },
    tooltip: {
        headerFormat: '<b>{point.x}</b><br/>',
        pointFormat: '{series.name}: {point.y}<br/>Total: {point.stackTotal}'

    },
    plotOptions: {
        column: {
            stacking: 'normal',
            dataLabels: {
                enabled: true,
                color: (Highcharts.theme && Highcharts.theme.dataLabelsColor) || 'white'
            }
        }
    },
    series: []
};

export default function RithmPerOperatorChart(prop) {
    const { series } = prop;

    //console.log('series', series);

    if (series) {
        let categories = [];
        let dataRithm = [];
        let dataLoggedTime = [];
        let dataTotalPneus = [];

        series.map(i => {
            categories.push(i.Usuario);
            dataRithm.push( Math.round( i.TotalPneus / i.LoggedTime, 2 ) );
            dataLoggedTime.push( Math.round( i.LoggedTime, 1 ) );
            dataTotalPneus.push( Math.round(i.TotalPneus) );
        })

        config = {
            ...config,
            xAxis: {
                categories: categories
            },

            series: [
                {
                    name: 'Ritmo',
                    data: dataRithm,
                    color:  CustomTheme.colors.COLOR_chart_barra_ritmo_serie_0
                },
                {
                    name: '# pneus',
                    type: 'spline',
                    data: dataTotalPneus,
                    yAxis: 1,
                    color:  CustomTheme.colors.COLOR_chart_barra_ritmo_serie_1
                },
                {
                    name: '# horas',
                    type: 'spline',
                    data: dataLoggedTime,
                    yAxis: 2,
                    color:  CustomTheme.colors.COLOR_chart_barra_ritmo_serie_2
                }

            ],
        }

    }


    return (
        <Card>
            <ReactHighcharts config = {config}>
            </ReactHighcharts>
        </Card>
    )
}
